/** Eight skill elements from gameplay_ideas. */

export const ELEMENTS = [
  'physical',
  'water',
  'fire',
  'wind',
  'earth',
  'lightning',
  'dark',
  'light',
] as const;

export type Element = (typeof ELEMENTS)[number];

export type ElementAffinity = 'weak' | 'resist' | 'immune' | 'neutral';

export function elementLabel(element: Element): string {
  switch (element) {
    case 'physical':
      return 'Vật lý';
    case 'water':
      return 'Nước';
    case 'fire':
      return 'Lửa';
    case 'wind':
      return 'Gió';
    case 'earth':
      return 'Đất';
    case 'lightning':
      return 'Sét';
    case 'dark':
      return 'Bóng tối';
    case 'light':
      return 'Ánh sáng';
  }
}

/** Damage multipliers: weak x1.5, resist x0.5, immune x0. */
export function affinityMultiplier(affinity: ElementAffinity): number {
  switch (affinity) {
    case 'weak':
      return 1.5;
    case 'resist':
      return 0.5;
    case 'immune':
      return 0;
    default:
      return 1;
  }
}

export function resolveAffinity(
  element: Element,
  weak: readonly Element[] = [],
  resist: readonly Element[] = [],
  immune: readonly Element[] = [],
): ElementAffinity {
  if (immune.includes(element)) {
    return 'immune';
  }
  if (weak.includes(element)) {
    return 'weak';
  }
  if (resist.includes(element)) {
    return 'resist';
  }
  return 'neutral';
}
